import React from 'react';
import * as S from './styles';

export default function VerticalRedirectableLinks() {
	return (
		<S.container>
			<h1>VerticalRedirectableLinks</h1>
		</S.container>
	);
}
